import React from 'react'
import { Text, Button } from '@rebrandly/styleguide'

import './Banner.css'
import SignUpButton from '../SignUpButton'
import { bool, string } from 'prop-types'

const Banner = ({color, isQr}) => {
  return (
    <div className={`Banner Banner--${color || 'blue'}`}>
      <div className='container'>
        <div className='Banner__content'>
          <Text size='3x-large'>Create an account to shorten links, generate QR codes, track link analytics, and more.</Text>
          <div><SignUpButton isQr={isQr}><Button theme='primary' size='x-lg'><span className='font-bold'>Sign up for free</span></Button></SignUpButton></div>
        </div>
      </div>
    </div>
  )
}

Banner.prototype = {
  color: string,
  isQr: bool
}

export default Banner
